<script lang="ts" setup>
import type { UIProp } from '~/types/elementsUi'

type CheckboxValue = boolean | string[] | number[] | undefined

type VCheckboxEmits = {
  click: []
  change: [value?: CheckboxValue]
}

interface VCheckboxProps {
  label?: string
  value: string | number | boolean | null // Name of this option
  disabled?: boolean
  circle?: boolean
  labelClass?: never
  checkboxLabelClass?: never
  idKey?: string
  ui?: UIProp<'label' | 'checkboxLabel'>
}

const emits = defineEmits<VCheckboxEmits>()
const props = withDefaults(defineProps<VCheckboxProps>(), {
  label: undefined,
  ui: undefined
})

const { t, te } = useI18n()

const modelValue = defineModel<any>()
</script>

<template>
  <label
    class="checkbox"
    :class="[circle && 'circle', disabled && 'disabled', ui?.label]"
    :for="idKey"
  >
    <input
      :id="idKey"
      v-model="modelValue"
      type="checkbox"
      class="checkbox-input"
      :value
      :disabled
      @change="emits('click')"
    />
    <span class="checkbox-element" />
    <span
      v-if="label || $slots['default']"
      class="checkbox-label"
      :class="[!$slots['default'] && !label && 'mr-0', ui?.checkboxLabel]"
    >
      <slot>
        {{ label && te(label) ? t(label) : label }}
      </slot>
    </span>
  </label>
</template>

<style scoped></style>
